import React from 'react';

export default class LeftTabbedGrayHeader extends React.Component {
    render() {
        var classes = [],
            style = Object.assign({}, this.props.style);

        if (this.props.className) {
            classes.push(this.props.className);
        }

        if (this.props.color) {
            classes.push(this.props.color);
        }

        var customColor;
        if (this.props.customColor) {
            customColor = <div className="custom-color" style={{backgroundColor: this.props.customColor}}></div>;
        }

        return (
            <h1 className={classes.join(' ')} style={style}>
                {customColor}
                <div className="inner-content">{this.props.children}</div>
            </h1>
        );
    }
}
